import { apiCall, API_CONFIG } from './api';

export const reelAPI = {
  createReel: async (reelData) => {
    const formData = new FormData();
    if (reelData.video instanceof File) {
      formData.append('video', reelData.video);
    }
    if (reelData.thumbnail instanceof File) {
      formData.append('thumbnail', reelData.thumbnail);
    }
    formData.append('title', reelData.title || '');
    formData.append('isActive', String(reelData.isActive !== undefined ? reelData.isActive : true));
    formData.append('region', reelData.region === 'india' ? 'india' : 'qatar');
    if (reelData.productId) formData.append('productId', reelData.productId);
    return apiCall(API_CONFIG.ENDPOINTS.REEL_VIDEO_CREATE, {
      method: 'POST',
      body: formData,
    });
  },

  getActiveReels: async (page = 1, limit = 20, region) => {
    const queryParams = new URLSearchParams({ page, limit });
    if (region) queryParams.set('region', region);
    return apiCall(`${API_CONFIG.ENDPOINTS.REEL_VIDEO_ACTIVE}?${queryParams}`, { method: 'GET' });
  },

  getInactiveReels: async (page = 1, limit = 20, region) => {
    const queryParams = new URLSearchParams({ page, limit });
    if (region) queryParams.set('region', region);
    return apiCall(`${API_CONFIG.ENDPOINTS.REEL_VIDEO_INACTIVE}?${queryParams}`, { method: 'GET' });
  },

  reorderReels: async (reorderData) => {
    return apiCall(API_CONFIG.ENDPOINTS.REEL_VIDEO_REORDER, {
      method: 'PUT',
      body: JSON.stringify(reorderData),
    });
  },

  updateReel: async (reelId, updateData) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.REEL_VIDEO_UPDATE}/${reelId}`, {
      method: 'PUT',
      body: JSON.stringify(updateData),
    });
  },

  deleteReel: async (reelId) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.REEL_VIDEO_DELETE}/${reelId}`, {
      method: 'DELETE',
    });
  },
};
